import { useCallback } from 'react';
import { LEADS_PERMISSION_ID } from '../../../../../data/constants/leadScan';
import { useEvent } from '../../../../../data/hooks/eventHooks';
import { useExhibitors } from '../../../../../data/hooks/exhibitor/exhibitorHooks';

export function useScannableSponsors(eventId) {
    const event = useEvent(eventId),
        sponsorsIds = event.permissions?.filter((p) => p.permission == LEADS_PERMISSION_ID)?.map((p) => p.sponsor_id),
        sponsorFilters = useCallback((exhibitor) => sponsorsIds.includes(exhibitor.id), [sponsorsIds]),
        sponsors = useExhibitors(eventId, { filter: sponsorFilters });

    return sponsors;
}
